import { Model } from "@shared-features/models/model";
import { Expose } from 'class-transformer';

export class FleetsClassificationCounts extends Model {
    @Expose() totalRegularFleetsCount:    number;
    @Expose() totalRentalFleetsCount:     number;
    @Expose() totalFreelancerFleetsCount: number;
    @Expose() lastRefreshTime:            number;
}
